import { useNavigate } from "react-router-dom";
import { Banner, List, Page, Spinner, Stack } from "@shopify/polaris";
import { useEffect } from "react";
import { useRejectedActions } from "../../../hooks/useRejectedActions.js";

const RejectedActionsBanner = ({ rejectedActions }) => {
  const { isLoading, actions, refetch } = useRejectedActions();

  useEffect(() => {
    if (rejectedActions.length !== actions.length && actions.length) {
      refetch()
    };
  }, [rejectedActions, refetch]);
  const navigate = useNavigate()

  return (
    <Page fullWidth>
      <Banner
        status={"warning"}
        title={"The following actions have exceeded your current plan subscription and have been disabled automatically. If you wish to enable them, please upgrade your plan or reduce the number of products/collections in this action."}
        action={{
          content: "Upgrade Plan",
          onAction: () => {
            navigate("/billing");
          }
        }}
      >
        {isLoading && <Stack distribution={"center"}><Spinner /></Stack>}
        {actions.length ? (
          <Stack vertical>
            <List type="bullet">
              {actions.map(action => (
                <List.Item key={action.id}>{action.name}</List.Item>
              ))}
            </List>
          </Stack>
        ) : null}
      </Banner>
    </Page>
  );
};

export default RejectedActionsBanner;